import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { BASE_URL } from "./Config";

export default function VerifyEmail() {
  const location = useLocation();
  const navigate = useNavigate();
  const { email } = location.state || {};

  const [otp, setOTP] = useState("");
  const [message, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(60); // 60 seconds
  const [resendDisabled, setResendDisabled] = useState(true);
  const [failedAttempts, setFailedAttempts] = useState(0);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setResendDisabled(false);
    }
    return () => clearInterval(interval);
  }, [timer]);
  // Countdown logic
  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();

    if (!otp) return setToastMessage("Please enter your OTP.");
    if (!/^\d{4}$/.test(otp)) return setToastMessage("OTP must be 4 digits.");

    try {
      setLoading(true);
      const response = await axios.post(`${BASE_URL}/verify_otp.php`, {
        otp,
        email,
      });

      const data = response.data;

      if (data.success) {
        setToastMessage("✅ OTP Verified Successfully!");
        setTimeout(() => {
          navigate("/reset-password", { state: { email } });
        }, 1500);
      } else {
        setToastMessage(data.message || "❌ Invalid OTP.");
      }
    } catch (error) {
      console.error(error);
      setToastMessage("❌ Error verifying OTP. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setResendDisabled(true);
      setToastMessage("Sending new OTP...");

      const response = await fetch(`${BASE_URL}/forgot_password.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json(); // ✅ Fetch returns a Response object, not data directly

      if (data.success) {
        setToastMessage("✅ New OTP sent!");
        setTimer(60); // Reset timer
      } else {
        setToastMessage(data.message || "❌ Invalid OTP.");
      }
    } catch (error) {
      console.error(error);
      setToastMessage("❌ Error sending OTP. Try again.");
    }
  };

  return (
    <div className="container pb-5">
      <div className="row">
        <div className="col-12 pt-5">
          <div className="logo">
            <Link to="/">
              <img
                src={`${BASE_URL}/images/fastrade_logo.jpg`}
                style={{ width: "220px" }}
                alt="Fast Trade "
              />
            </Link>
          </div>
        </div>
        <div className="col-12 pt-4">
          <div className="login-form">
            <form onSubmit={handleSendOtp}>
              <div className="form-page">
                {message && (
                  <div className="status-message alert alert-info">
                    {message}
                  </div>
                )}

                <h2>Personal Account</h2>
                <p style={{ width: "270px" }}>
                  We've sent a verification code to <b>{email}</b>. Enter it
                  below.
                </p>

                <div className="inputs pt-3">
                  <input
                    type="text"
                    placeholder="Enter 4-digit OTP"
                    className="number_input"
                    value={otp}
                    // style={{fontWeight:"700",textAlign:"center", letterSpacing:"25px"}}
                    onChange={(e) => setOTP(e.target.value)}
                    maxLength={4}
                  />
                </div>

                <div className="submit-btn pt-3">
                  <input
                    type="submit"
                    value={loading ? "Verifying..." : "Confirm"}
                    className="btn btn-primary"
                    style={{
                      width: "100%",
                      backgroundColor: "#128DE5",
                      padding: "10px",
                      marginBottom: "15px",
                      fontWeight: "600",
                    }}
                    disabled={loading}
                    required
                  />
                </div>
                <div
                  className="pt-3 text-muted fontstyle2"
                  style={{ textAlign: "center", fontWeight: "700" }}
                >
                  Remaining Time: <strong>{formatTime(timer)}</strong>
                </div>

                <div
                  className="pt-3 text-center fontstyle2 "
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <button
                    type="button"
                    onClick={handleResendOtp}
                    disabled={resendDisabled}
                    className="btn btn-link"
                    style={{
                      textAlign: "center",
                      fontWeight: "800",
                      color: "#128DE5",
                      textDecoration: "none",
                      filter: resendDisabled ? "blur(1px)" : "none",
                      background: "transparent",
                    }}
                  >
                    {resendDisabled ? `RESEND OTP` : "RESEND OTP"}
                  </button>
                </div>

                <div>
                  <p
                    style={{
                      margin: "0px",
                      textAlign: "center",
                      width: "264px",
                      lineHeight: "13px",
                    }}
                  >
                    <sapn
                      style={{
                        fontSize: "11px",
                        fontWeight: "500",
                        color: "darkgrey",
                      }}
                    >
                      <b>Note :</b> Please do not refresh this page while
                      verifying your OTP.
                    </sapn>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
